import {BE} from '@utils';

import {LoginRequestModel} from './login-request.model';

import BESchema = BE.BESchema;

@BESchema()
export class LoginFormModel extends LoginRequestModel {
	public rememberMe = false;
	/* -------------------------------------------------- */

	constructor(init?: Partial<LoginFormModel>) {
		super(init);
		if (init) Object.assign(this, init);
	}
}
